import { render, staticRenderFns } from "./Contact-picker.vue?vue&type=template&id=fdfdf94a&scoped=true&"
import script from "./Contact-picker.vue?vue&type=script&lang=js&"
export * from "./Contact-picker.vue?vue&type=script&lang=js&"
import style0 from "./Contact-picker.vue?vue&type=style&index=0&id=fdfdf94a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfdf94a",
  null
  
)

export default component.exports